import { log } from 'log';

export const parseJwtToken = <T = any>(token: string): T => {
    let parsedToken;

    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(window.atob(base64).split('')
        .map((c) => `%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`)
        .join(''));

    try {
        parsedToken = JSON.parse(jsonPayload);
    } catch {
        log('error', 'unable to parse JWT token', token);
    }

    return parsedToken;
};
